<template>
  <div class="customize-tabs-panel">
    <div class="customize-tabs-panel__arrow" />
    <div class="customize-tabs-panel__content">
      <div class="customize-tabs-panel__header">
        <p class="customize-tabs-panel__title">
          {{ $t('CHAT_LIST.CUSTOMIZE_TABS.TITLE') }}
        </p>
        <p class="customize-tabs-panel__subtitle">
          {{ $t('CHAT_LIST.CUSTOMIZE_TABS.SUBTITLE') }}
        </p>
      </div>
      <div class="customize-tabs-panel__divider" />
      <template v-for="(group, index) in groups">
        <div :key="group.key" class="customize-tabs-panel__group">
          <button
            type="button"
            class="customize-tabs-panel__group-header"
            @click="$emit('select-group', group.key)"
          >
            <span class="customize-tabs-panel__group-label">
              {{ group.label }}
            </span>
            <span
              class="customize-tabs-panel__radio"
              :class="{ 'is-checked': group.selected }"
            />
          </button>
          <draggable
            v-if="group.selected"
            :list="group.items"
            handle=".customize-tabs-panel__drag-handle"
            animation="150"
            ghost-class="customize-tabs-panel__ghost"
            @end="$emit('reorder', group.key, group.items)"
          >
            <div
              v-for="item in group.items"
              :key="item.key"
              class="customize-tabs-panel__item"
            >
              <span
                class="customize-tabs-panel__drag-handle material-symbols-outlined"
              >
                drag_indicator
              </span>
              <span class="customize-tabs-panel__item-label">
                {{ item.label }}
              </span>
              <input
                type="checkbox"
                class="semantic-checkbox"
                :checked="item.visible"
                @change="$emit('toggle-item', group.key, item.key)"
              />
            </div>
          </draggable>
        </div>
        <div
          v-if="index < groups.length - 1"
          :key="`divider-${group.key}`"
          class="customize-tabs-panel__divider"
        />
      </template>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable';

export default {
  components: { draggable },
  props: {
    groups: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.customize-tabs-panel {
  @apply absolute z-20 pt-2 w-[210px];

  &__arrow {
    @apply absolute top-0 left-[12px] w-4 h-2 bg-white;
    clip-path: polygon(50% 0, 0% 100%, 100% 100%);
    filter: drop-shadow(0px 4px 4px rgba(15, 24, 40, 0.1));
  }

  &__content {
    @apply relative flex flex-col gap-2 bg-white rounded-lg px-2 py-2;
    box-shadow: 0 1px 3px 0 rgba(15, 24, 40, 0.10), 0 1px 2px 0 rgba(15, 24, 40, 0.06);
  }

  &__header {
    @apply flex flex-col gap-0.5;
  }

  &__title {
    @apply text-sm font-semibold text-gray-800 leading-[18px] m-0;
  }

  &__subtitle {
    @apply text-xs font-normal text-gray-500 leading-[18px] m-0;
  }

  &__divider {
    @apply h-px bg-gray-100;
  }

  &__group {
    @apply flex flex-col gap-0.5;
  }

  &__group-header {
    @apply flex items-center justify-between gap-1 p-1 rounded cursor-pointer bg-transparent border-0 w-full;

    &:hover {
      @apply bg-gray-50;

      .customize-tabs-panel__radio {
        @apply border-green-500;
      }
    }
  }

  &__group-label {
    @apply text-sm font-semibold text-gray-600;
  }

  &__radio {
    @apply relative shrink-0 w-[18px] h-[18px] rounded-full border border-gray-400 box-border;

    &.is-checked {
      @apply border-green-500;

      &::after {
        content: '';
        @apply absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-3 h-3 rounded-full bg-green-500;
      }
    }
  }

  &__item {
    @apply flex items-center justify-between gap-1 p-1 rounded;

    &:hover {
      @apply bg-gray-50;
    }
  }

  &__drag-handle {
    @apply cursor-grab text-gray-400 select-none;
    font-size: 16px;
    line-height: 1;
  }

  &__item-label {
    @apply flex-1 text-sm font-normal text-gray-600;
  }

  &__ghost {
    @apply opacity-50;
  }
}
</style>
